import { useQuery } from '@tanstack/react-query';

import { scudMappingApi } from '@/shared/api/scudMapping';
import { IScudMappingPermissions } from '@/shared/types/scudMapping.types';

const NO_ACCESS: IScudMappingPermissions = { is_admin: false, locations: [] };

export const SCUD_MAPPING_PERMISSIONS_KEY = ['scud_mapping_permissions'];

/** Права на «Сопоставление пропусков СКУД»: локации из сервисных пропусков пользователя, админу — все */
export const useScudMappingPermissions = () => {
	const {
		data = NO_ACCESS,
		isPending,
		isError,
		error,
	} = useQuery({
		queryKey: SCUD_MAPPING_PERMISSIONS_KEY,
		queryFn: scudMappingApi.getPermissions,
		staleTime: 300_000,
		retry: false,
	});

	return {
		permissions: data,
		isAvailable: data.is_admin || data.locations.length > 0,
		isPending,
		isError,
		error,
	};
};
